import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {alabaster} from '/theme/color/on.color';
import {
  alto,
  green,
  magenta,
  orangeRed,
  pearlGreen,
  salmonPink,
  skyblue,
} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  base: {
    marginTop: 0,
    paddingTop: 0,
    marginBottom: 0,
  },
  profileAttribute: {
    borderRadius: 8,
    backgroundColor: alabaster,
    marginBottom: indent * 0.4,
    marginTop: 2,
    paddingVertical: indent * 0.4,
    paddingLeft: indent,
    paddingRight: indent * 0.35,
  },
});

export const dispositionColorByName = {
  ['Ready to Purchase']: green,
  ['On the Fence']: pearlGreen,
  ['Price Issue']: orangeRed,
  ['Not Interested']: alto,
  ['Unable to reach/Invalid data']: magenta,
  ['Do Not Contact']: salmonPink,
  ['New']: skyblue,
};
